/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum SurveyQuestionType {
    WholeNumber = 0,
    Decimal = 1,
    Toggle = 2,
    Date = 3,
    Text = 4,
    MultilineText = 5,
    File = 6,
    DropDown = 7,
    ImageTwoDimensions = 8,
    ImageThreeDimensions = 9,
}
